const TIMER_MODE = {
    GT_1HOUR: 'gt_1hour',
    GT_5MIN_LT_1HOUR: 'gt_5min_lt_1hour',
    LT_5MIN: 'lt_5min',
}

export default TIMER_MODE
